import { render, staticRenderFns } from "./ItemAttributeFilterSelection.vue?vue&type=template&id=c6f50dc6&scoped=true"
import script from "./ItemAttributeFilterSelection.vue?vue&type=script&lang=ts"
export * from "./ItemAttributeFilterSelection.vue?vue&type=script&lang=ts"
import style0 from "./ItemAttributeFilterSelection.vue?vue&type=style&index=0&id=c6f50dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f50dc6",
  null
  
)

export default component.exports